import { useEffect } from "react";

export const SITE_URL = "https://randylovelessband.com";

const upsertMeta = (attr, key, content) => {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

/**
 * Per-route <head> manager. No external dependency — updates the existing
 * tags from index.html so output stays clean (and is captured by prerendering).
 */
export const Seo = ({ title, description, path = "/", image, noindex = false }) => {
  useEffect(() => {
    if (title) {
      document.title = title;
      upsertMeta("property", "og:title", title);
      upsertMeta("name", "twitter:title", title);
    }
    if (description) {
      upsertMeta("name", "description", description);
      upsertMeta("property", "og:description", description);
      upsertMeta("name", "twitter:description", description);
    }
    const url = SITE_URL + path;
    upsertMeta("property", "og:url", url);
    upsertLink("canonical", url);
    upsertMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    if (image) {
      upsertMeta("property", "og:image", image);
      upsertMeta("name", "twitter:image", image);
    }
  }, [title, description, path, image, noindex]);

  return null;
};
